<script lang="ts">
	import type { Block } from '$models/Block/Block';
	import type { Component } from 'svelte';

	type DeferredBlockLoader = () => Promise<{ default: Component<any> }>;

	interface Props {
		block: Block;
		loadComponent: DeferredBlockLoader;
	}

	let { block, loadComponent }: Props = $props();
	const { default: BlockComponent } = await loadComponent();
</script>

<BlockComponent {block} />
